<div class="booking-container">
    <label *ngIf="!isInquiry" class="heading mt-3 ml-3">
        Your Appointment Details
    </label>
    <label *ngIf="isInquiry" class="heading mt-3 ml-3">
        Your Enquiry Details
    </label>

    <div class="mx-2 mt-4">
        <div class="row m-0" *ngIf="isCategoryVisible">
            <label class="label col-5">Category</label>
            <label class="value col-7">{{data.category?.category_name}}</label>
        </div>
        <div class="row m-0" *ngIf="isMemberVisible">
            <label class="label col-5">{{data?.personnelLabel}}</label>
            <label class="value col-7">{{data.member?.personnel}}</label>
        </div>

        <div *ngIf="!isInquiry">
            <div class="row m-0">
                <label class="label col-5">Date</label>
                <label class="value col-7">{{data.date}}</label>
            </div>
            <div class="row m-0">
                <label class="label col-5">Time</label>
                <label class="value col-7">{{show12HrTime(data.time?.slot_time)}}</label>
            </div>
        </div>

        <hr *ngIf="isCategoryVisible || isMemberVisible || !isInquiry" class="my-2 mx-4">

    </div>

    <div class="mx-2 mt-4">
        <div class="row m-0">
            <label class="label col-5">Name</label>
            <label class="value col-7">{{data.name}}</label>
        </div>
        <div class="row m-0">
            <label class="label col-5">Phone Number</label>
            <label class="value col-7">{{data.phone}}</label>
        </div>
        <div class="row m-0">
            <label class="label col-5">Email ID</label>
            <label class="value col-7">{{data.email}}</label>
        </div>

        <div class="row m-0" *ngIf="showVideoConf">
            <label class="label col-5">Video Conference</label>
            <label class="value col-7">{{data.isVideoConf}}</label>
        </div>

        <div class="row m-0" *ngFor="let field of flexData;">
            <label class="label col-5">{{field.field_name}}</label>
            <label class="value col-7">{{field.value}}</label>
        </div>

    </div>


</div>
